// Language-independent config: icons, images, ordering, spans
import {
  Building2, BadgeCheck, Banknote, CreditCard, ShieldCheck,
  MonitorSmartphone, FileCode2, Briefcase,
} from "lucide-react";

export const WHATSAPP = "12408176538";
export const WHATSAPP_DISPLAY = "+1 (240) 817-6538";
export const OWNER_EMAIL = "Alexaguzman407@gmail.com";
export const ALEXA_PHOTO = "/alexa.webp";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1709377195538-5522ed0f9e10?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxkYXJrJTIwbHV4dXJ5JTIwYWJzdHJhY3QlMjBnb2xkJTIwYmxhY2t8ZW58MHx8fHwxNzg1Mjk5OTY0fDA&ixlib=rb-4.1.0&q=85",
  manifesto: "https://images.unsplash.com/photo-1634549709262-508c47d4c229?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbHV4dXJ5JTIwYWJzdHJhY3QlMjBnb2xkJTIwYmxhY2t8ZW58MHx8fHwxNzg1Mjk5OTY0fDA&ixlib=rb-4.1.0&q=85",
  office: "https://images.unsplash.com/photo-1699621106755-4fe40ce95d64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBkYXJrfGVufDB8fHx8MTc4NTI5OTk2M3ww&ixlib=rb-4.1.0&q=85",
  portfolio: "https://images.unsplash.com/photo-1604074131228-9d48b811bd80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwd2Vic2l0ZSUyMG1vY2t1cCUyMHNjcmVlbnxlbnwwfHx8fDE3ODUyOTk5NjR8MA&ixlib=rb-4.1.0&q=85",
  fundingBg: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

// 8 services (order matches i18n services.items)
export const SERVICE_ICONS = [
  Building2, BadgeCheck, Banknote, CreditCard, ShieldCheck, MonitorSmartphone, FileCode2, Briefcase,
];
export const SERVICE_SPANS = [
  "lg:col-span-6", "lg:col-span-6",
  "lg:col-span-4", "lg:col-span-4", "lg:col-span-4",
  "lg:col-span-5", "lg:col-span-3", "lg:col-span-4",
];

// Portfolio images + spans (order matches i18n.portfolio.items)
export const PORTFOLIO_MEDIA = [
  { img: IMAGES.office, span: "lg:col-span-8" },
  { img: IMAGES.portfolio, span: "lg:col-span-4" },
  { img: IMAGES.manifesto, span: "lg:col-span-4" },
  { img: IMAGES.hero, span: "lg:col-span-8" },
];

// LLC pricing highlight (order matches i18n.pricing.plans)
export const PRICING_HIGHLIGHT = [false, true];
// Website packages highlight (order matches i18n.websites.packages)
export const WEBSITE_HIGHLIGHT = [false, true, false];
